export default __webpack_public_path__ + "static/media/puppies.5157a2bd.jpg";